export const Failed_Load = 'Failed_Load';

export const UPDATE_GRID = 'UPDATE_GRID';
export const FILTER_ROWS = 'FILTER_ROWS';

export const SET_CDP_DATA = 'SET_CDP_DATA';

export const EDIT_MODE_SWITCHER = "EDIT_MODE_SWITCHER";
export const STORE_REF_DATA = "STORE_REF_DATA";